module.exports = __webpack_public_path__ + "img/command.232ef1d8.svg";